import React, {useEffect} from "react";
import LoginPage from "./pages/LoginPage/LoginPage";
import WelcomePage from "./pages/Welcome/WelcomePage";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import UserProfile from "./pages/UserProfile/UserProfile";
import UserProfileUpdated from "./pages/UserProfileUpdated/UserProfileUpdated";
import MainPage from "./pages/MainPage/MainPage";
import TabPanel from "./components/Tabs/Tabs.jsx";
import texts from './assets/texts.json';
import TextsContext from './TextsContent';
import './assets/css_variables.css';
import WorkoutPage from "./pages/WorkoutPage/WorkoutPage";
import RoutesToPages from "./assets/RoutesToPages/Routes";
import CalendarPage from "./pages/CalendarPage/CalendarPage";
import WorkoutSetupPage from "./pages/WorkoutSetupPage/WorkoutSetupPage";
import WorkoutExercisesPage from "./pages/WorkoutExercisesPage/WorkoutExercisesPage";
import WorkoutStartTraining from "./pages/WorkoutStartTraining/WorkoutStartTraining";
import WorkoutFeedback from "./pages/WorkoutFeedback/WorkoutFeedback";
import SleepPage from "./pages/SleepPage/SleepPage";
import SleepTipsPage from "./pages/SleepTipsPage/SleepTipsPage";
import WaterBalance from "./pages/WaterBalance/WaterBalance";
import WaterChallenge from "./pages/WaterChallenge/WaterChallenge";
import WaterChallengeOpen from "./pages/WaterChallengeOpen/WaterChallengeOpen";
import FoodCategory from "./pages/FoodCategory/FoodCategory.jsx";
import Foods from "./pages/Foods/Foods.jsx";
import {useVhProperty} from "./assets/functionsBehavior/SetValueVh";
import Terms from "./pages/Terms/Terms";
import './App.css'
import Unsubscription from "./pages/Unsubscription/Unsubscription";
import UnsubscriptionSuccess from "./pages/Unsubscription/UnsubscriptionSuccess";
import TestResults from "./pages/TestResults/TestResults";


const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationPath = location.pathname;

  useVhProperty();

  useEffect(() => {
    const routes = Object.values(RoutesToPages);
    const isExistingRoute = routes.some(route => route === locationPath);

    if (!isExistingRoute) {
      navigate(RoutesToPages.welcomePage);
    }
  }, []);

  useEffect(() => {
    // Заборона pinch-zoom
    const handleTouchMove = (e) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    // Заборона double-tap zoom
    let lastTouchEnd = 0;
    const handleTouchEnd = (e) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 100) {
        e.preventDefault();
      }
      lastTouchEnd = now;
    };

    document.addEventListener("touchmove", handleTouchMove, {passive: false});
    document.addEventListener("touchend", handleTouchEnd, {passive: false});

    return () => {
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);

  const userProfileData = JSON.parse(localStorage.getItem('userProfileData'));

  useEffect(() => {
    // if (!userProfileData) {
    //   navigate(RoutesToPages.welcomePage);
    // }
    if (userProfileData && location.pathname === RoutesToPages.userProfile) {
      navigate(RoutesToPages.mainPage);
    }
  }, []);

  return (
    <TextsContext.Provider value={texts}>
      <div className="App">
        <Routes>
          <Route path='/' element={<WelcomePage/>}/>
          <Route path='login-page' element={<LoginPage/>}/>
          <Route path='login-page/user-profile' element={<UserProfile/>}/>
          <Route path='main-page' element={<MainPage/>}/>
          <Route path='user-profile' element={<UserProfileUpdated/>}/>
          <Route path='workout' element={<WorkoutPage/>}/>
          <Route path='workout/workout-setup' element={<WorkoutSetupPage/>}/>
          <Route path='workout/workout-exercises' element={<WorkoutExercisesPage/>}/>
          <Route path='calendar' element={<CalendarPage/>}/>
          <Route path='workout/workout-start-training' element={<WorkoutStartTraining/>}/>
          <Route path='workout/workout-feedback' element={<WorkoutFeedback/>}/>
          <Route path='sleep-page' element={<SleepPage/>}/>
          <Route path='sleep-page/sleep-tips' element={<SleepTipsPage/>}/>
          <Route path='water-balance' element={<WaterBalance/>}/>
          <Route path='water-balance/challenge' element={<WaterChallenge/>}/>
          <Route path='water-balance/challenge/open' element={<WaterChallengeOpen/>}/>
          <Route path='food-category' element={<FoodCategory/>}/>
          <Route path='food-category/:category' element={<Foods/>}/>
          <Route path='terms' element={<Terms/>}/>
          <Route path='unsubscribe/*' element={<Unsubscription/>}/>
          <Route path='unsubscriptionSuccess' element={<UnsubscriptionSuccess/>}/>
          <Route path='test-result-page' element={<TestResults/>}/>
        </Routes>
        <TabPanel/>
      </div>
    </TextsContext.Provider>
  );
};

export default App;
